<div class="d-flex flex-column w-100">
  <span class="menus-back-btn" (click)="goBack()">
    <i class="pi pi-arrow-left me-4"></i>{{'DASHBOARD.BACK' | translate}}</span>
  <p-progressSpinner class="w-100 text-center pos_menu_details_spinner" *ngIf="spinner"></p-progressSpinner>
</div>
<div class="d-flex justify-content-center mt-3" style="max-height: calc(100% - 80px);" *ngIf="!spinner">
  <div class="d-flex flex-column justify-content-center division-menu-items-container">
    <span class="top-label mb-4">{{'MENU_ITEM.MENU_ITEMS' | translate}}</span>
    <div class="division-table-container">
      <p-table [value]="menuItems" class="align-self-center w-100" [breakpoint]="'620px'">
        <ng-template pTemplate="header">
          <tr>
            <th>{{'DASHBOARD.NAME' | translate}}</th>
            <th>{{'DASHBOARD.QUANTITY' | translate}}</th>
            <th>{{'DASHBOARD.AMOUNT' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>
              <b class="p-column-title">{{'DASHBOARD.NAME' | translate}}</b>
              <div class="ellipsis">{{item.name}}</div>
            </td>
            <td>
              <b class="p-column-title">{{'DASHBOARD.QUANTITY' | translate}}</b>
              {{item.quantity}}
            </td>
            <td>
              <b class="p-column-title">{{'DASHBOARD.AMOUNT' | translate}}</b>
               {{item.amount}} {{currency}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

